"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOvertimePreviewSkippedCheckDto = instanceOfOvertimePreviewSkippedCheckDto;
exports.OvertimePreviewSkippedCheckDtoFromJSON = OvertimePreviewSkippedCheckDtoFromJSON;
exports.OvertimePreviewSkippedCheckDtoFromJSONTyped = OvertimePreviewSkippedCheckDtoFromJSONTyped;
exports.OvertimePreviewSkippedCheckDtoToJSON = OvertimePreviewSkippedCheckDtoToJSON;
exports.OvertimePreviewSkippedCheckDtoToJSONTyped = OvertimePreviewSkippedCheckDtoToJSONTyped;
/**
 * Check if a given object implements the OvertimePreviewSkippedCheckDto interface.
 */
function instanceOfOvertimePreviewSkippedCheckDto(value) {
    if (!('zealEmployeeCheckId' in value) || value['zealEmployeeCheckId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function OvertimePreviewSkippedCheckDtoFromJSON(json) {
    return OvertimePreviewSkippedCheckDtoFromJSONTyped(json, false);
}
function OvertimePreviewSkippedCheckDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'zealEmployeeCheckId': json['zealEmployeeCheckId'],
        'status': json['status'],
    };
}
function OvertimePreviewSkippedCheckDtoToJSON(json) {
    return OvertimePreviewSkippedCheckDtoToJSONTyped(json, false);
}
function OvertimePreviewSkippedCheckDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'zealEmployeeCheckId': value['zealEmployeeCheckId'],
        'status': value['status'],
    };
}
//# sourceMappingURL=OvertimePreviewSkippedCheckDto.js.map